/* eslint-disable import/prefer-default-export */
import React from 'react';
import { SkeletonNew } from './SkeletonNew';
import GameThumbnailList, { SectionWrapper } from '../GameThumbnailList';
import { providerFilter, searchFilter } from './FilteredGames';
import useQuery from '../../../hooks/useQuery';
import useActiveGames from '../../../hooks/games/useActiveGames';
import usePlayer from '../../../hooks/usePlayer';
import { useRecommendedGames } from '../../../hooks/games/useRecommendedGames';

export const RecommendedGames = () => {
  const { games, state } = useRecommendedGames();
  const { query } = useQuery();
  const searchText = query.get('search');
  const { activeProvider } = useActiveGames();
  const { player } = usePlayer();

  if (state === 'error') {
    return null;
  }

  if (state === 'loading') {
    return (
      <SectionWrapper>
        <h2 className="is-size-4 has-text-weight-bold has-text-primary container has-text-centered">
          {player?.partyId ? 'Recommended for you' : 'Recommended'}
        </h2>
        <div
          id="game-grid"
          className="m-game-grid columns is-multiline is-mobile parent-grid skeleton"
        >
          {new Array(6).fill(true).map((_, i) => (
            <SkeletonNew key={i} />
          ))}
        </div>
      </SectionWrapper>
    );
  }

  const filteredGames = games
    ?.filter(game => searchFilter(game, searchText))
    ?.filter(game => providerFilter(game, activeProvider?.id, 'provider'));

  const filteredCategory = {
    id: 999998,
    slug: 'recommended',
    name: 'Recommended',
    displayGamesCount: 12,
    display_name: player?.partyId ? 'Recommended for you' : 'Recommended',
    moreGamesToDisplay: 0,
    position: 0,
    showWinnersList: false,
    isMobile: false,
    loadAllGames: true,
    games: filteredGames?.map((game) => ({
      ...game,
      mega_thumb: false,
      vertical_thumbnail: {},
    })),
    count: filteredGames?.length,
    totalCount: filteredGames?.length,
  };

  return (
    <GameThumbnailList
      category={filteredCategory}
      maxLimit={filteredCategory?.displayGamesCount}
    />
  );
};
